import {Tool} from "./Tool";
import {Handler} from "./Handler";
import {BoxedObjectEditor} from "./BoxedObjectEditor";

export class SelectTool extends Tool {

	constructor() {
		super();
		this.start = {x: 0, y: 0};
		this.down = false;
		this.dragging = false;
		/** @type {ManipulationEditor} */
		this.hitObject = null;
		this.clicked = [];
		this.dragMarque = false;
	}


	getCursor() {
		return "default";
	}

	/**
	 * @param {CanvasRenderingContext2D} ctx
	 */
	drawAfterModel(ctx, pixelWidth) {
		if (this.dragging && this.dragMarque && this.marque) {
			ctx.save();
			const bx = BoxedObjectEditor.strokeBox(
				(this.start.x + this.marque.x) / 2,
				(this.start.y + this.marque.y) / 2,
				Math.abs(this.marque.x - this.start.x),
				Math.abs(this.marque.y - this.start.y),
				pixelWidth
			);
			ctx.lineWidth = pixelWidth;
			ctx.setLineDash([4, 4]);
			ctx.strokeRect(bx.left, bx.top, bx.width, bx.height);
			ctx.restore();
		}
	}

	/**
	 * @param {MouseEvent} e
	 * @param canvas
	 */
	mouseDown(e, canvas) {
		this.down = true;
		this.start = Tool.normalizeEvent(e, canvas);

		/** @type {[ManipulationEditor]} */
		const objs = canvas.getManipulables();
		let found = SelectTool.findHit(objs, this.start.x, this.start.y);

		this.dragMarque = found === null;

		if (found === null) {
			if (!e.shiftKey) {
				let wasSelection = false;
				for (let o of objs) {
					wasSelection = wasSelection || o.selected;
					o.selected = false
				}
				this.clicked = [];
				return wasSelection;
			} else this.selectedToClicked(objs);
		} else if (found instanceof Handler) {
			this.clicked = [ found ];
		} else {
			if (e.shiftKey) {
				found.selected = !found.selected;
			} else {
				const wasSelected = found.selected;
				if (!wasSelected) {
					for (let o of objs) {
						o.selected = o === found;
					}
				}
			}
			this.selectedToClicked(objs);
			return true;
		}
		return false;
	}

	selectedToClicked(objs) {
		this.clicked = [];
		for (let o of objs) {
			if (o.selected) this.clicked.push(o);
		}
	}

	static findHit(objs, x, y) {
		for (let i = objs.length - 1; i >= 0; i--) {
			let o = objs[i];
			let clicked = o.hit(x, y);
			if (clicked !== null) return clicked;
		}
		return null;
	}

	mouseUp(e, canvas) {
		this.down = false;
		return this.stopDragging(e, canvas);
	}

	mouseMove(e, canvas) {
		const pos = Tool.normalizeEvent(e, canvas);

		if (this.dragging) {
			if (this.dragMarque) this.selectMarque(e, canvas);
			else {
				for (let cl of this.clicked) {
					cl.drag(pos.x - this.start.x, pos.y - this.start.y, this.snaps.horizontal, this.snaps.vertical);
				}
			}
			return true;
		} else {
			if (this.down) {
				if (Math.abs(pos.x - this.start.y) >= 3 || Math.abs(pos.y - this.start.y) >= 3) {
					if (this.dragMarque) this.startMarque(e, canvas);
					else this.startDragging(e, canvas);
					return true;
				}
			}
		}
		return false;
	}

	doubleClick(e, canvas) {
		const pos = Tool.normalizeEvent(e, canvas);
		const objs = canvas.getManipulables();
		const found = SelectTool.findHit(objs, pos.x, pos.y);
		if (found) return found.doubleClick(e, canvas, pos);
		return false;
	}

	startDragging(e, canvas) {
		const pos = Tool.normalizeEvent(e, canvas);
		this.dragging = true;
		const objs = canvas.getManipulables();
		this.snaps = {
			vertical: [],
			horizontal: []
		};
		for (let o of objs) {
			if (!o.selected) {
				this.snaps.horizontal = this.snaps.horizontal.concat(o.horizontalSnaps());
				this.snaps.vertical = this.snaps.vertical.concat(o.verticalSnaps());
			}
		}
		for (let cl of this.clicked) {
			cl.startDragging();
			cl.drag(pos.x - this.start.x, pos.y - this.start.y, [], []);
		}
	}

	startMarque(e, canvas) {
		this.dragging = true;
		this.selectMarque(e, canvas);
	}

	selectMarque(e, canvas) {
		this.marque = Tool.normalizeEvent(e, canvas);
		const marque = {
			top: Math.min(this.start.y, this.marque.y),
			left: Math.min(this.start.x, this.marque.x),
			bottom: Math.max(this.start.y, this.marque.y),
			right: Math.max(this.start.x, this.marque.x)
		};
		const objs = canvas.getManipulables();
		for (let o of objs) {
			//if (o.selected) continue;
			if (o instanceof BoxedObjectEditor) {
				const bb = o.calcBoundingBox();
				bb.right = bb.left + bb.width;
				bb.bottom = bb.top + bb.height;
				o.selected = SelectTool.intersect(bb, marque);
			}
		}
	}

	static intersect(r1, r2) {
		if (r1.left > r2.right || r2.left > r1.right) return false;
		if (r1.top > r2.bottom || r2.top > r1.bottom) return false;
		return true;
	}

	stopDragging(e, canvas) {
		if (this.dragging) {
			const pos = Tool.normalizeEvent(e, canvas);
			this.dragging = false;
			for (let cl of this.clicked) {
				cl.stopDragging(pos.x - this.start.x, pos.y - this.start.y, this.snaps.horizontal, this.snaps.vertical);
			}
			return true;
		}
		return false;
	}
}